import React from 'react'
import TeamMemberCard from '../TeamMemberCard/TeamMemberCard';

import style from './css/team.module.css'

import director from '../../assets/director1.jpg'
import kate from '../../assets/kateebinum.jpeg'
import adegbite from '../../assets/mr_adegbite.jpg'
import casmir from '../../assets/mr-casmir.png'
import james from '../../assets/jamesishaku.jpeg'
import joy from '../../assets/joy.jpeg'
import monisola from '../../assets/monisola-fanisi.JPG'
import emmanuel from '../../assets/Emmanuel-Ikyor.jpeg'
import michael from  '../../assets/michael.jpeg'
// import mercy from  '../../assets/mercy-godwin.png'
import bella from  '../../assets/isabella.png'


const Team = () => {
    const teamMembers = [
        { image: director, altText: "Mr. Joseph Ebinum", name: "Mr. Joseph Ebinum", designation: "Chairman" },
        { image: kate, altText: "Mrs. Kate Ebinum", name: "Mrs. Kate Ebinum", designation: "Executive Director" },
        { image: adegbite, altText: "Mr. Olusegun Adegbite", name: "Mr. Olusegun Adegbite", designation: "General Manager" },
        { image: joy, altText: "Mrs. Joy Edobor", name: "Mrs. Joy Edobor", designation: "AGM Sales and Operations" },
        { image: casmir, altText: "Mr. Casmir Adumekwe", name: "Mr. Casmir Adumekwe", designation: "Business Manager" },
        { image: james, altText: "Mr. James Ishaku", name: "Mr. James Ishaku", designation: "Centre Academic Head" },
        { image: monisola, altText: "Ms. Monisola Fanisi", name: "Ms. Monisola Fanisi", designation: "HOM / Academic Counsellor" },
        { image: michael, altText: "Mr. Michael Cousin", name: "Mr. Michael Cousin", designation: "Deputy Centre Academic Head" },
        { image: emmanuel, altText: "Mr. Ikyor Terna Emmanuel", name: "Mr. Ikyor Terna Emmanuel", designation: "Faculty" }, 
        // { image: mercy, altText: "Ms. Mercy Godwin", name: "Ms. Mercy Godwin", designation: "Faculty" }, 
        { image: bella, altText: "Ms. Bonou Isabella Yeyinu", name: "Ms. Bonou Isabella Yeyinu", designation: "Office/Account Assistant" }, 
    ];

  return (
    <section className={style.teamContainer}>
        <div className={style.headerContainer}>
            <header className={style.teamHeader}>
                <h2 className={style.teamTitle}>Our Team</h2>
                <p className={style.teamMainText}>This is who we are</p>
            </header>
            <div className={style.teamCardContainer}>
            {teamMembers.map((member, index) => (
                <TeamMemberCard key={index} image={member.image} alternative={member.altText} name={member.name} designation={member.designation} />
            ))}
        </div>
        </div>
    </section>
  )
}

export default Team